import { Flex } from '@/components/atoms/Grid'
import { AddToCartButton } from '@/components/molecules/iconButtons'
import { FC } from 'react'
import { useWishlistDispatch } from '@/providers/wishlistDispatchProvider'
import HeartButton from '@/components/atoms/heartButton'
import { Product } from '@/network/graphql.g'
import { useWishlist } from '@/providers/wishlistProvider'

type ProductDetailAddToCartProps = {
  onAddToCartAction: () => Promise<void>
  product: Product
  disabled?: boolean
  addImmediately?: boolean
} & Rest

const ProductDetailAddToCart: FC<ProductDetailAddToCartProps> = ({
  onAddToCartAction,
  product,
  addImmediately = false,
  ...rest
}) => {
  const { addToWishlist, removeFromWishlist } = useWishlistDispatch()
  const { isInWishlist } = useWishlist()

  return (
    <Flex width="100%" alignItems="center" {...rest}>
      <AddToCartButton
        width="100%"
        onClick={onAddToCartAction}
        productId={product?.id}
        addImmediately={addImmediately}
        data-testid="productDetailAddToCart"
      />
      <HeartButton
        ml={20}
        mr="6px"
        height={27}
        width={24}
        isFilled={isInWishlist(product)}
        onClick={(e) => {
          e.preventDefault()
          isInWishlist(product)
            ? removeFromWishlist(product)
            : addToWishlist(product)
        }}
        data-testid="wishlistButton"
      />
    </Flex>
  )
}

export default ProductDetailAddToCart
